import SweetAlert from "react-bootstrap-sweetalert";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  VStack,
  HStack,
  IconButton,
  } from "@chakra-ui/react";
import { AddIcon, DeleteIcon } from "@chakra-ui/icons";
import React, { useState, useEffect } from "react";
import scheduleService from "services/report/scheduleService";

const ModalPengajuanJadwal = ({ isOpen, onClose, onSuccess }) => {
  const [form, setForm] = useState({
    pemohon: localStorage.getItem("nama") || "",
    nip: localStorage.getItem("nip") || "",
    tanggal: "",
    id_upi: "",
    nm_upi: "",
    alamat: "",
    kota: "",
    propinsi: "",
    id_izin: "",
    jenis_izin: "",
    sts_pengajuan: "",
    personil: [{ NIP: "", NAMA: "", JABATAN: "" }],
    produk: [{ id_produk: "", nama_produk: "", grade: "" }]
    });


  const [upiList, setUpiList] = useState([]);
  const [pegawaiList, setPegawaiList] = useState([]);
  const [produkList, setProdukList] = useState([]);
  const [izinList, setIzinList] = useState([]);
  const [alert, setAlert] = useState(null);

  // Ambil Izin
  useEffect(() => {
  const fetchIzin = async () => {
    try {
      const res = await scheduleService.getIzin();

      // pastikan data berbentuk array
      if (Array.isArray(res.data)) {
        setIzinList(res.data);
      } else {
        console.error("Format data izin tidak valid:", res.data);
        setIzinList([]);
      }
    } catch (err) {
      console.error("Gagal mengambil data Izin", err);
    }
  };

  fetchIzin();
}, []);


  // Ambil UPI
  useEffect(() => {
    const fetchUpi = async () => {
      try {
        const res = await scheduleService.getUpi();
        setUpiList(res.data);
      } catch (err) {
        console.error("Gagal mengambil data UPI", err);
      }
    };
    fetchUpi();
  }, []);

  // Ambil Pegawai
  useEffect(() => {
    const fetchPegawai = async () => {
      try {
        const res = await scheduleService.getPegawaiInsp();
        setPegawaiList(res.data);
      } catch (err) {
        console.error("Gagal mengambil data Pegawai", err);
      }
    };
    fetchPegawai();
  }, []);

  // Ambil Produk
  useEffect(() => {
    const fetchProduk = async () => {
      try {
        const res = await scheduleService.getProduk();
        setProdukList(res.data);
      } catch (err) {
        console.error("Gagal mengambil data Produk", err);
      }
    };
    fetchProduk();
  }, []);


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleIzinChange = (e) => {
  const selectedId = e.target.value;
  // Cari objek izin yang lengkap dari list
  const selectedIzin = izinList.find((ji) => String(ji.ID_IZIN) === String(selectedId));

  setForm({
    ...form,
    id_izin: selectedId, // Simpan ID-nya
    jenis_izin: selectedIzin ? selectedIzin.JENIS_IZIN : "" // Simpan Nama-nya
  });
};

  

  const handlePegawaiChange = (index, field, value) => {
    setForm((prev) => {
      const updated = [...prev.personil];
      updated[index] = { ...updated[index], [field]: value };
      return { ...prev, personil: updated };
    });
  };

  const addPersonil = () => {
    setForm((prev) => ({
      ...prev,
      personil: [...prev.personil, { NIP: "", NAMA: "", NOREG: "" , JABATAN:""}],
    }));
  };

  const removePersonil = (i) => {
    const clone = [...form.personil];
    clone.splice(i, 1);
    setForm({ ...form, personil: clone });
  };

  // Handle Produk
const handleProdukChange = (i, id_produk) => {
  const prod = produkList.find(p => p.id_produk === Number(id_produk));
  if (!prod) return;

  setForm(prev => {
    const updated = [...prev.produk];
    updated[i] = {
      ...updated[i],
      id_produk: prod.id_produk,
      nama_produk: prod.nama_produk
    };
    return { ...prev, produk: updated };
  });
};

const handleGradeChange = (i, grade) => {
  setForm(prev => {
    const updated = [...prev.produk];
    updated[i] = {
      ...updated[i],
      grade
    };
    return { ...prev, produk: updated };
  });
};




  const addProduk = () => {
    setForm(prev => ({
      ...prev,
      produk: [...prev.produk, { id_produk: "", nama_produk: "", grade: "" }]
    }));
  };


  const removeProduk = (i) => {
    const clone = [...form.produk];
    clone.splice(i, 1);
    setForm({ ...form, produk: clone });
  };

  // Handle UPI
  const handleUpiChange = (e) => {
  const upi = upiList.find(u => u.UPI_ID === Number(e.target.value));
  if (!upi) return;

  setForm(prev => ({
    ...prev,
    id_upi: upi.UPI_ID,
    nm_upi: upi.UPI_NAMA,
    alamat: upi.UPI_ALAMAT,
    kota: upi.kota?.URAIAN_KOTA || "",
    propinsi: upi.provinsi?.URAIAN_PROPINSI || ""
  }));
};


  // Submit
const handleSubmit = async () => {
  if (!form.tanggal || !form.id_upi || !form.id_izin) {
    setAlert(
      <SweetAlert
        error
        title="Gagal!"
        onConfirm={() => setAlert(null)}
      >
        Semua field harus diisi.
      </SweetAlert>
    )
    return;
  }

  const payload = {
    TANGGAL: form.tanggal,
    TANGGAL_KEMBALI: form.tanggal_kembali,
    PEMOHON: form.pemohon,
    NIP: form.nip,
    ID_UPI: form.id_upi,
    NM_UPI: form.nm_upi,
    ALAMAT: form.alamat,
    ID_PROP: form.id_upi,
    PROP: form.propinsi,
    ID_KOTA: form.id_upi,
    KOTA: form.kota,
    ID_IZIN: form.id_izin,
    JENIS_IZIN: form.jenis_izin,
    sts_pengajuan: form.sts_pengajuan,
    personil: form.personil,
    produk: form.produk
  };

try {
    await scheduleService.createPengajuan(payload);

    setAlert(
      <SweetAlert
        success
        title="Berhasil!"
        onConfirm={() => {
          setAlert(null);
          onSuccess();
          onClose();
        }}
      >
        Pengajuan jadwal berhasil disimpan.
      </SweetAlert>
    );

  } catch (error) {
    console.error("Gagal menyimpan:", error);

    setAlert(
      <SweetAlert
        danger
        title="Gagal!"
        onConfirm={() => setAlert(null)}
      >
        Terjadi kesalahan saat menyimpan pengajuan.
      </SweetAlert>
    );
  }
};


  return (
    <>
    {alert}
    <Modal isOpen={isOpen} onClose={onClose} size="4xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Input Pengajuan Jadwal</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <VStack spacing={4} align="stretch">

            {/* Pemohon */}
            <HStack spacing={4}>
              <FormControl>
                <FormLabel>Pemohon</FormLabel>
                <Input value={form.pemohon} isReadOnly />
              </FormControl>

              <FormControl>
                <FormLabel>NIP</FormLabel>
                <Input value={form.nip} isReadOnly />
              </FormControl>
            </HStack>

            {/* UPI */}
            <FormControl>
              <FormLabel>Nama UPI</FormLabel>
              <Select
                placeholder="Pilih UPI"
                value={form.id_upi}
                onChange={handleUpiChange}
              >
                {upiList.map(u => (
                  <option key={u.UPI_ID} value={u.UPI_ID}>
                    {u.UPI_NAMA}
                  </option>
                ))}
              </Select>
            </FormControl>

            <Input placeholder="Alamat" value={form.alamat} isReadOnly />

            <HStack>
              <Input placeholder="Kota" value={form.kota} isReadOnly />
              <Input placeholder="Provinsi" value={form.propinsi} isReadOnly />
            </HStack>

            {/* Tanggal */}
            <HStack>
            <FormControl>
              <FormLabel>Tanggal</FormLabel>
              <Input
                type="date"
                name="tanggal"
                value={form.tanggal}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Tanggal Selesai</FormLabel>
              <Input
                type="date"
                name="tanggal_kembali" // Samakan dengan key di state
                value={form.tanggal_kembali}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Jenis Tugas</FormLabel>
              <Select
                placeholder="Pilih Jenis Izin"
                value={form.id_izin} // Gunakan id_izin sebagai value
                onChange={handleIzinChange}
              >
                {izinList.map((ji) => (
                  <option key={ji.ID_IZIN} value={ji.ID_IZIN}>
                    {ji.JENIS_IZIN}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel>Keterangan</FormLabel>
              <Select
                name="sts_pengajuan"
                placeholder="Pilih Status Pengajuan"
                value={form.sts_pengajuan} 
                onChange={handleChange}
                >
                  <option value="Baru">Baru </option>
                  <option value="Perpanjangan">Perpanjangan</option>
                </Select>
            </FormControl>
            </HStack>

            {/* Personil */}
            <FormControl>
              <FormLabel>Personil</FormLabel>
              {form.personil.map((p, i) => (
                <HStack key={i} mb={2}>
                  <Select
                    placeholder="Pilih Pegawai"
                    value={p.NIP}
                    onChange={(e) => {
                      const pegawai = pegawaiList.find(
                        (pg) => pg.NIP === e.target.value
                      );
                      if (pegawai) {
                        handlePegawaiChange(i, "NIP", pegawai.NIP);
                        handlePegawaiChange(i, "NAMA", pegawai.NAMA);
                        handlePegawaiChange(i, "NOREG", pegawai.NOREG || "");
                        handlePegawaiChange(i, "JABATAN", pegawai.JABATAN || "");
                      }
                    }}
                  >
                    {pegawaiList.map((pg) => (
                      <option key={pg.NIP} value={pg.NIP} >
                        {pg.NAMA} - {pg.NIP}, 
                      </option>
                    ))}
                  </Select>

                  <Input placeholder="NIP" value={p.NIP} isReadOnly />
                  <Input placeholder="No Reg Inspektur" value={p.NOREG} isReadOnly />
                  <Input placeholder="Jabatan" value={p.JABATAN} isReadOnly />
                     
                  {i > 0 && (
                    <IconButton
                      icon={<DeleteIcon />}
                      size="sm"
                      colorScheme="red"
                      onClick={() => removePersonil(i)}
                    />
                  )}
                </HStack>
                
                
              ))}

              <Button mt={2} size="sm" colorScheme="blue" onClick={addPersonil}>
                + Tambah Personil
              </Button>
            </FormControl>

            {/* Produk */}
            <FormControl>
              <FormLabel>Produk</FormLabel>
              {form.produk.map((p, i) => (
                <HStack key={i} mb={2}>
                  <Select
                      placeholder="Pilih Produk"
                      value={p.id_produk}
                      onChange={(e) => handleProdukChange(i, e.target.value)}
                    >
                      {produkList.map(pg => (
                        <option key={pg.id_produk} value={pg.id_produk}>
                          {pg.nama_produk}
                        </option>
                      ))}
                    </Select>
                  <Select
                    placeholder="Grade"
                    value={p.grade}
                    onChange={(e) => handleGradeChange(i, e.target.value)}
                  >
                    <option value="A">A</option>
                    <option value="B">B</option>
                    <option value="C">C</option>
                  </Select>


                  {i > 0 && (
                    <IconButton
                      icon={<DeleteIcon />}
                      size="sm"
                      colorScheme="red"
                      onClick={() => removeProduk(i)}
                    />
                  )}
                </HStack>
              ))}

              <Button
                leftIcon={<AddIcon />}
                size="sm"
                onClick={addProduk}
              >
                Tambah Produk
              </Button>
            </FormControl>

          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" onClick={handleSubmit}>
            Simpan
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
    </>
  );
};

export default ModalPengajuanJadwal;
